import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const LeadSchema = z.object({
  type: z.enum(["newsletter", "sms", "contact", "bulk", "influencer", "wholesale", "back_in_stock", "review"]),
  email: z.string().trim().email().max(320).optional(),
  phone: z.string().trim().min(5).max(32).optional(),
  name: z.string().trim().min(1).max(200).optional(),
  payload: z.record(z.any()).default({}),
  utm: z.record(z.any()).default({}),
  source: z.string().max(200).optional(),
}).refine((d) => d.email || d.phone, { message: "Email or phone required" });

export const submitLead = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => LeadSchema.parse(data))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { error } = await supabaseAdmin.from("leads").insert({
      type: data.type,
      email: data.email ?? null,
      phone: data.phone ?? null,
      name: data.name ?? null,
      payload: data.payload,
      utm: data.utm,
      source: data.source ?? null,
    });
    if (error) return { ok: false, error: error.message };
    return { ok: true };
  });
